import GalleryFiles from './GalleryFiles'

export * from './GalleryFiles'
export default GalleryFiles
